import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useParams } from 'react-router';

import { usePixelsByIds } from '@/api/pixel';
import { PageSpinner } from '@/components/loaders';
import { Page, PageFilterProvider } from '@/components/page';
import { ReturnToLink } from '@/components/ReturnToLink';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';
import { PIXEL_GROUP_MAX_LIMIT } from '@/constants/numbers';
import { ROUTES } from '@/router';

import PixelDetailContent from './PixelDetailContent';
import PixelDetailErrorOrChildren from './PixelDetailErrorOrChildren';
import PixelTagList from './PixelTagList';

const PixelDetail = () => {
  const { pixels: pixelIdString } = useParams();
  const pixelIds = pixelIdString?.split(',');
  const { pixels, isLoading } = usePixelsByIds(pixelIds);
  const isGrouped = !!(pixelIds && pixelIds?.length > 1);

  const pageTitle = isGrouped ? t`Grouped (${pixelIds?.length})` : pixels?.[0].name;

  return (
    <Page
      title={t`Pixel Reporting`}
      pageName={pageTitle}
      exampleAIQuestions={exampleAIQuestions('pixel')}
    >
      <div className="flex w-full flex-col gap-6">
        <div className="flex items-start justify-between gap-8">
          <ReturnToLink route={ROUTES.pixels.path} routeName={<Trans>Pixel Overview</Trans>} />
          <PixelTagList pixels={pixels} />
        </div>
        <PageFilterProvider>
          <PixelDetailErrorOrChildren pixelIds={pixelIds} maxLimit={PIXEL_GROUP_MAX_LIMIT}>
            {isLoading ? (
              <PageSpinner />
            ) : (
              <PixelDetailContent pixelIds={pixelIds} pixels={pixels} />
            )}
          </PixelDetailErrorOrChildren>
        </PageFilterProvider>
      </div>
    </Page>
  );
};

export default PixelDetail;
